import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { theme } from '@prophecy/theme';
import styled from 'styled-components';
import { AsteriskIcon } from './AsteriskIcon';
export const StyledLabelWrapper = styled.div `
  display: flex;
  align-items: flex-start;
  white-space: nowrap;
  gap: ${theme.spaces.x2};
`;
export const renderRequiredLabel = ({ label, required }) => {
    return label ? (_jsxs(StyledLabelWrapper, { children: [required && label && _jsx(AsteriskIcon, {}), label] })) : null;
};
